import {otsBaseApi} from "../../ots-api";
import {ServiceEventTicketPolicy} from "../../../model/service/service-event-ticket-policy";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: [
    "ServiceEventTicketPolicies",
    "ServiceEventTicketPoliciesByEventType",
    "ObjectObjectChangeLogs"
  ]
});

const serviceEventTicketPolicyApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllServiceEventTicketPolicies: builder.query<ServiceEventTicketPolicy[], { companyId?: string, regionId?: string }>({
      query: ({companyId, regionId}) => ({
        url: `/service-event-ticket-policies/all`,
        method: "GET",
        params: removeUndefined({
          companyId: companyId,
          regionId: regionId
        })
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ServiceEventTicketPolicies", id} as const)),
            {type: "ServiceEventTicketPolicies", id: "LIST"}
          ];
        } else {
          return [{type: "ServiceEventTicketPolicies", id: "LIST"}];
        }
      }
    }),
    getAllServiceEventTicketPoliciesByEventType: builder.query<ServiceEventTicketPolicy[], {
      eventType: string
      companyId?: string
      regionId?: string
    }>({
      query: ({eventType, companyId, regionId}) => ({
        url: `/service-event-ticket-policies/event-type/${eventType}`,
        method: "GET",
        params: removeUndefined({
          companyId: companyId,
          regionId: regionId
        })
      }),
      providesTags: (result, error, {eventType}) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ServiceEventTicketPolicies", id} as const)),
            {type: 'ServiceEventTicketPoliciesByEventType', id: eventType},
          ];
        } else {
          return [{type: "ServiceEventTicketPoliciesByEventType", id: eventType}];
        }
      }
    }),
    getServiceEventTicketPolicy: builder.query<ServiceEventTicketPolicy, string>({
      query: (id) => ({
        url: `/service-event-ticket-policies/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ServiceEventTicketPolicies", id}]
    }),
    createServiceEventTicketPolicy: builder.mutation<ServiceEventTicketPolicy, Partial<ServiceEventTicketPolicy>>({
      query: (mapping) => ({
        url: "/service-event-ticket-policies",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [
        {type: "ServiceEventTicketPolicies", id: "LIST"},
        {type: "ServiceEventTicketPoliciesByEventType"},
      ]
    }),
    updateServiceEventTicketPolicy: builder.mutation<ServiceEventTicketPolicy, Partial<ServiceEventTicketPolicy>>({
      query: (mapping) => ({
        url: "/service-event-ticket-policies",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "ServiceEventTicketPolicies", id},
        {type: "ObjectObjectChangeLogs", id},
        {type: "ServiceEventTicketPoliciesByEventType"},
      ]
    }),
    deleteServiceEventTicketPolicy: builder.mutation<void, Partial<ServiceEventTicketPolicy>>({
      query: (mapping) => ({
        url: "/service-event-ticket-policies",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "ServiceEventTicketPolicies", id},
        {type: "ServiceEventTicketPoliciesByEventType"},
      ]
    }),
  })
});

export const {
  useGetServiceEventTicketPolicyQuery,
  useGetAllServiceEventTicketPoliciesQuery,
  useGetAllServiceEventTicketPoliciesByEventTypeQuery,
  useCreateServiceEventTicketPolicyMutation,
  useUpdateServiceEventTicketPolicyMutation,
  useDeleteServiceEventTicketPolicyMutation,
} = serviceEventTicketPolicyApi;
